import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import styled from 'styled-components';
import { Commons } from 'components';
import StatusControlModal from 'components/Bill/Modal/StatusControlModal';

const propTypes = {
  approval: PropTypes.array
};

class BillApprovals extends Component {
  handleClick = (e, stepNumber) => {
    const { name } = e.target;
    this.props.onOpenModal(name, stepNumber);
  };

  billAcceptedReject = (id, stepNumber) => {
    const { billAccepted, iIdx } = this.props;
    billAccepted('delete', id, iIdx, stepNumber);
  };

  render() {
    const {
      approval,
      iIdx,
      billRejected,
      billParentRejected,
      billAccepted,
      modalIf,
      modalFn,
      detail,
      onOpenModal
    } = this.props;
    const parentApproval = detail.parentApproval;
    const company = storage.get('company');
    const storageUserId = (company || {}).userID;
    const tabledata = {
      header: {
        main: [
          { data: '결재 순서', textAlign: 'left' },
          { data: 'ID', textAlign: 'left' },
          { data: '이름', textAlign: 'left' },
          { data: '직책', textAlign: 'left' },
          { data: '상태', textAlign: 'left' },
          { data: '사용자 타입', textAlign: 'left' },
          { data: '결재 상태', textAlign: 'center' }
        ]
      },
      body: {
        message: '-',
        main: []
      }
    };

    let main = cm.tableHeaderList(tabledata.header.main, 3, false, 'default', null, true);

    tabledata.header.main = main;
    let border = { row: [] };
    let userInfos = {
      id: '',
      signId: '',
      name: ''
    };

    if (approval && approval.length > 0) {
      // 테이블 리스트
      const cancel = {};
      approval.forEach((item, idx) => {
        const { status, stepNumber } = item;
        if (item.status === 'ACCEPTED') {
          cancel.accepted = {
            stepNumber
          };
        } else if (item.status === 'PROCESSING') {
          cancel.processing = {
            stepNumber
          };
        } else if (item.status === 'PENDING') {
          cancel.pending = {
            stepNumber
          };
        } else if (item.status === 'REJECTED') {
          cancel.rejected = true;
        }
      });
      approval.forEach((item, pIdx) => {
        const { status, stepNumber, users } = item;
        const bodyTemp = users.map((user, cIdx) => {
          const { userInfo, updated } = user;
          const updatedYMD = cm.yyyyMMdd(updated);
          const updatedHMS = cm.hhmmss(new Date(updated));
          let approvalStatus = '-';
          switch (status) {
            case 'ACCEPTED':
              if (user.status === 'ACCEPTED') {
                userInfos = {
                  id: userInfo.id,
                  signId: userInfo.signId,
                  name: userInfo.name
                };
                approvalStatus = (
                  <div>
                    {updatedYMD} {updatedHMS} 결재 완료
                    {!cancel.rejected &&
                    userInfo.signId === storageUserId &&
                    cancel.accepted.stepNumber !== approval.length &&
                    cancel.accepted.stepNumber === stepNumber ? (
                      <CancelBtn inverted color="red" onClick={(e) => this.billAcceptedReject(userInfo.id, stepNumber)}>
                        승인 취소
                      </CancelBtn>
                    ) : null}
                  </div>
                );
              }

              break;

            case 'PROCESSING':
              if (userInfo.signId === storageUserId) {
                userInfos = {
                  id: userInfo.id,
                  signId: userInfo.signId,
                  name: userInfo.name
                };
                if (
                  detail.range &&
                  ((detail.range.type === 'PARENT' && detail.range.acceptedAll === true) ||
                    detail.range.type === 'DIVISION')
                ) {
                  approvalStatus = (
                    <div style={{ textAlign: 'center' }}>
                      <Button
                        style={{ marginRight: 8 }}
                        inverted
                        color="red"
                        name="REJECT BUTTON"
                        onClick={(e) => this.handleClick(e, stepNumber)}
                      >
                        반려
                      </Button>
                      <Button
                        inverted
                        color="green"
                        name="ACCEPT BUTTON"
                        onClick={(e) => this.handleClick(e, stepNumber)}
                      >
                        청구서 승인
                      </Button>
                    </div>
                  );
                } else {
                  approvalStatus = '-';
                }
              }
              break;

            case 'REJECTED':
              if (user.status === 'REJECTED') {
                if (parentApproval && parentApproval.approvalMessage) {
                  approvalStatus = '-';
                } else {
                  approvalStatus = (
                    <div style={{ color: 'red' }}>
                      {updatedYMD} {updatedHMS} 반려
                    </div>
                  );
                }
              }
              break;
          }

          const userStatus = cm.statusTypeNameV2(userInfo.status, userInfo.isDormant);
          const userGrade = cm.gradeTypeNameV2(userInfo.grade);
          border.row.push(pIdx + cIdx === stepNumber - 1 ? true : false);
          let obj = {
            row: [
              {
                data: pIdx + cIdx === stepNumber - 1 ? stepNumber : null,
                textAlign: 'left',
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              },
              {
                data: userInfo.signId,
                textAlign: 'left',
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              },
              {
                data: userInfo.name,
                textAlign: 'left',
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              },
              {
                data: userInfo.rankPosition,
                textAlign: 'left',
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              },
              {
                data: userStatus.text,
                textAlign: 'left',
                fontColor: userStatus.fontColor,
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              },
              {
                data: userGrade.text,
                textAlign: 'left',
                fontColor: userGrade.fontColor,
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              },
              {
                data: approvalStatus,
                textAlign: 'center',
                border: pIdx + cIdx === stepNumber - 1 ? true : false
              }
            ]
          };
          obj = cm.defalutTableStaffDivisionSet(obj.row, 3, userInfo.orgCode, null, null, true);
          return obj;
        });

        bodyTemp.forEach((rowItem) => {
          tabledata.body.main.push(rowItem);
        });
      });
    }

    return (
      <StyledContent>
        <div className="table-box approval-table">
          <Commons.TableForm tabledata={tabledata} />
        </div>
        {modalFn &&
        (modalFn.btnName === 'ACCEPT BUTTON' ||
          modalFn.btnName === 'REJECT BUTTON' ||
          modalFn.btnName === 'PARENT REJECT BUTTON') ? (
          <StatusControlModal
            modalFn={modalFn}
            modalIf={modalIf}
            iIdx={iIdx}
            userInfo={userInfos}
            billRejected={billRejected}
            billParentRejected={billParentRejected}
            billAccepted={billAccepted}
          />
        ) : null}
      </StyledContent>
    );
  }
}

BillApprovals.propTypes = propTypes;

const StyledContent = styled.section``;
const CancelBtn = styled(Button)`
  &&&& {
    margin-left: 10px;
  }
`;

export default BillApprovals;
